module.exports = __webpack_public_path__ + "static/media/event-image.086799e2.webp";